if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('[data-kk-add-label], span');
        const variantInput = this.form && this.form.querySelector('[name="id"]');
        if (this.submitButton && variantInput && variantInput.value) {
          this.submitButton.setAttribute('data-kk-add-to-cart', variantInput.value);
        }
        if (window.KKCart && typeof window.KKCart.syncButtons === 'function') {
          window.KKCart.syncButtons();
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      noticeAlreadyInCart(variantId) {
        if (variantId && window.KKCart) {
          window.KKCart.variantIds[String(variantId)] = true;
        }
        if (window.KKCart && typeof window.KKCart.goToCart === 'function') {
          window.KKCart.goToCart();
          return;
        }
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }

      isAlreadyInCartError(payload) {
        const text = [payload && payload.description, payload && payload.message, payload && payload.errors]
          .flat()
          .filter(Boolean)
          .join(' ');
        return /already in (your )?cart|maximum quantity/i.test(String(text));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const pendingVariantId = this.form.querySelector('[name="id"]') && this.form.querySelector('[name="id"]').value;
        const startAdd = () => this.submitAddToCart(evt);

        if (pendingVariantId && window.KKCart && window.KKCart.hasVariant(pendingVariantId)) {
          this.noticeAlreadyInCart(pendingVariantId);
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { credentials: 'same-origin' })
          .then((res) => res.json())
          .then((cart) => {
            this.submitButton.removeAttribute('aria-disabled');
            if (window.KKCart) {
              window.KKCart.seed((cart.items || []).map((item) => item.variant_id || item.id));
            }
            const exists = (cart.items || []).some(
              (item) => String(item.variant_id) === String(pendingVariantId) || String(item.id) === String(pendingVariantId)
            );
            if (exists) {
              this.noticeAlreadyInCart(pendingVariantId);
              return;
            }
            startAdd();
          })
          .catch(() => {
            this.submitButton.removeAttribute('aria-disabled');
            startAdd();
          });
      }

      submitAddToCart(evt) {
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (this.isAlreadyInCartError(response)) {
                this.noticeAlreadyInCart(variantId);
                this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
                linesUpdateDeferred?.reject(new Error(response.description || response.message));
                return;
              }
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            if (window.KKCart && typeof window.KKCart.mark === 'function') {
              window.KKCart.mark(variantId);
            } else if (window.KKCart) {
              window.KKCart.variantIds[String(variantId)] = true;
              if (typeof window.KKCart.syncButtons === 'function') window.KKCart.syncButtons();
            }
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            if (this.isAlreadyInCartError({ message: e && e.message })) {
              this.noticeAlreadyInCart(variantId);
            } else {
              console.error(e);
            }
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const variantId = this.form && this.form.querySelector('[name="id"]') && this.form.querySelector('[name="id"]').value;
        const inCart = variantId && window.KKCart && window.KKCart.hasVariant(variantId);
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = inCart ? 'Go to Cart' : window.variantStrings.addToCart;
        }
        if (window.KKCart && typeof window.KKCart.syncButtons === 'function') window.KKCart.syncButtons();
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        if (deferred && deferred.promise) deferred.promise.catch(() => {});
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
